import React from 'react';
import './Backdrop.css';

const Backdrop = ({ isVisible, onClick }) => {
  return (
    <button
      type="button"
      className={`mobile-backdrop ${isVisible ? 'visible' : ''}`}
      onClick={onClick}
      aria-label="Close menu"
      aria-hidden={!isVisible}
      tabIndex={isVisible ? 0 : -1}
    />
  );
};

export default Backdrop;
